import React from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/NewFooter/Footer';
import Nextlevel from '../../components/NextLevel/Nextlevel';
import TheMikvahCustomerStory from './CustomerStory/TheMikvahStory';
import TeaneckCustomerStory from './CustomerStory/TeaneckMikvahStory';
import BelzCustomerStory from './CustomerStory/BelzMikvahStory';
import MoreStories from './MoreStories/MoreStories';
import './MikvahStory.scss';
import { useTranslation} from 'react-i18next';
const MikvahStory = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <>
            <Header alwaysSticky={true} />
            {props.location==="carroll"?
                <TheMikvahCustomerStory />
            : props.location==="teaneck"?
                <TeaneckCustomerStory />
            : props.location==="belz"?
                <BelzCustomerStory />
            :null}
            <Nextlevel 
                className= "cmikvah-next-level"
                title= {t("HomeCtaTitle")}
                description1= {t("HomeCtaBody")}
                btn1= "contact sales"
                btn1Link= "/sign-up"
                btn2= "view plans"
                btn2Link="/mikvah-plans"
            />
            <MoreStories />
            <Footer />
        </>
    )
}

export default MikvahStory